import {
	scrollToForum,
	scrollToId,
	scrollToElement,
	rememberForumScroll,
	readForumScroll,
	clearForumScroll,
} from '@vvg/forum/js/scroll.js';


export default {
	methods: {
		scrollToForum,
		scrollToId,
		scrollToElement,
		rememberForumScroll,
		readForumScroll,
		clearForumScroll,
	},
};
